import React from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { useEffect, useRef } from "react";
import { Trans } from "react-i18next";
import { Form } from "react-bootstrap";
import { t } from "i18next";
// import LocationField from "../fields/LocationField";
// import LocationSearchInput2 from "../../../jobs/SearchBarComponents/LocationSearchInput2";
import NewLocationInput2 from "../../../jobs/SearchBarComponents/NewLocationInput2";

function ResumeLocationForm({ location, register, setValue, control, errors, fieldObj, clearErrors, getValues, inputField, setInputField, companyID }) {

  useEffect(() => {
    clearErrors()
    location?.map((field, index) => {
      setValue("profileAddressLocation", field?.text)
      setValue("profileLocation", field?.address);
      setValue("profilePostalCode", field?.postalCode);
      setValue("profileCity", field?.city);
      setValue("profileCountry", field?.country != "" && field?.country != null ? field?.country : field?.countryCanonical);
      setValue("profileState", field?.state);
    });
  }, []);
  // console.log(getValues(), "sdfksdnfksndf");
  function prepareLocation(address) {
    clearErrors(["profileAddressLocation", "profileLocation", "profilePostalCode", "profileCity", "profileCountry", "profileState"]);
    // console.log(address, "wjgrbnjgbjbwjefb");
    if (address) {
      let address1 = "";
      const getComponent = (types) =>
        address.addressComponents?.find((c) =>
          types.some((t) => c.types.includes(t))
        )?.longText || "";
      const cityCode = getComponent(["locality", "postal_town"]);
      const state = getComponent(["administrative_area_level_1"]);
      const country = getComponent(["country"]);
      const postcode = getComponent(["postal_code"]);
      const lat = address?.location?.lat || 0;
      const lng = address?.location?.lng || 0;
      if (address?.addressComponents?.find((x) => x?.types?.includes("street_number"))) {
        address1 += address.addressComponents.find((x) => x?.types?.includes("street_number"))?.longText + " "
      }
      if (address?.addressComponents?.find((x) => x?.types?.includes("route"))) {
        address1 += address.addressComponents.find((x) => x?.types?.includes("route"))?.longText
      }
      setValue("profileAddressLocation", address?.formattedAddress ? address?.formattedAddress : address?.display_name);
      setValue("profileLocation", address1);
      setValue("profilePostalCode", postcode);
      setValue("profileCity", cityCode);
      setValue("profileCountry", getValues()?.profileCountry == country ? getValues()?.profileCountry : country);
      setValue("profileState", state);
      setValue("profileLocationLat", lat);
      setValue("profileLocationLng", lng)
    }
  }
  const handleAddressChange = (address) => {
    if (address) {
      prepareLocation(address);
    }
  };

  const handlePostalCodeChange = (postalCode) => {
    if (postalCode) {
      prepareLocation(postalCode);
    }
  };
  const handleCityChange = (city) => {
    if (city) {
      prepareLocation(city);
    }
  };
  const handleStateChange = (state) => {
    if (state) {
      prepareLocation(state);
    }
  };
  const handleCountryChange = (country) => {
    if (country) {
      if (country) {
        prepareLocation(country);
      }
    }
  };

  return (
    <>
     { inputField == "Single" ? 
      <div className="col" id={fieldObj?.fieldCode}>
          <label>
            <Trans i18nKey="address" defaults="Address" />
          </label>
          <Controller
            control={control}
            name="profileAddressLocation"
            refs={register("profileAddressLocation", {
              // required: false,
              required: true,
              validate:{
                  emptyValue: (v) => v.replace(/\s/g, "") != ""
                }
            })}
            // defaultValue=""
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="w-100">
                {/* <Form.Control
                  size="sm"
                  className="w-100"
                  placeholder={ t("enterLocation", { defaultValue: "Enter Location" })}
                  value={value}
                  onChange={onChange}
                /> */}
                <NewLocationInput2
                  handlePlaceChange={handleAddressChange}
                  onChange={onChange}
                  value={value}
                  placeholder="Enter Location"
                  size={'sm'}
                  className={'locationInput pt-2'}
                  autoSuggestCssClassName={'w-100'}
                  page={'Search'}
                  setInputField={setInputField}
                  inputField={inputField}
                  companyID={companyID}
                />
              </div>
            )}
          />
          {errors?.profileAddressLocation && (
            <span className="text-danger pt-2">
              {errors?.profileAddressLocation?.message || t("pleaseProvideatleastPostalCode", { defaultValue: "Please provide at least Postal Code" })}
            </span>
          )}
        </div>
      : 
     <>
      <div className="col" id={fieldObj?.fieldCode}>
          <label>
            <Trans i18nKey="address" defaults="Address" />
          </label>
          <Controller
            control={control}
            name="profileLocation"
            refs={register("profileLocation", {
              required: false
            })}
            // defaultValue=""
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="w-100">
                <Form.Control
                  size="sm"
                  className="w-100"
                  placeholder={ t("enterLocation", { defaultValue: "Enter Location" })}
                  value={value}
                  onChange={onChange}
                />
                {/* <NewLocationInput2
                  handlePlaceChange={handleAddressChange}
                  onChange={onChange}
                  value={value}
                  placeholder="Enter Location"
                  size={'sm'}
                  className={'locationInput pt-2'}
                  autoSuggestCssClassName={'w-100'}
                  page={'Search'}
                /> */}
              </div>
            )}
          />
        </div>
        <div className="col" id={fieldObj?.fieldCode}>
          <label>
            <Trans i18nKey="postalCode" defaults="Postal Code" />
            <span className="text-danger">{"*"}</span>
          </label>
          <Controller
            control={control}
            name="profilePostalCode"
            refs={register("profilePostalCode", {
              required: true,
              validate:{
                  emptyValue: (v) => v.replace(/\s/g, "") != ""
                }
            })}
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="w-100">
                <NewLocationInput2
                  handlePlaceChange={handleAddressChange}
                  onChange={onChange}
                  value={value}
                  placeholder="Enter Location"
                  size={'sm'}
                  className={'locationInput pt-2'}
                  autoSuggestCssClassName={'w-100'}
                  page={'Search'}
                />
              </div>
            )}
          />
          {errors?.profilePostalCode && (
            <span className="text-danger">
              {errors?.profilePostalCode?.message || t("postalCodeRequired", { defaultValue: "PostalCode is required" })}
            </span>
          )}
        </div>
        <div className="col">
          <label>
            <Trans i18nKey="city" defaults="City" />
            <span className="text-danger">{"*"}</span>
          </label>
          <Controller
            control={control}
            name="profileCity"
            refs={register("profileCity", {
              required: true,
              validate: {
                  emptyValue: (v) => v.replace(/\s/g, "") != "",
                }
            })}
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="w-100" id={fieldObj?.fieldCode}>
                <NewLocationInput2
                  handlePlaceChange={handleAddressChange}
                  onChange={onChange}
                  value={value}
                  placeholder="Enter Location"
                  size={'sm'}
                  className={'locationInput pt-2'}
                  autoSuggestCssClassName={'w-100'}
                  page={'Search'}
                />
              </div>
            )}
          />
          {errors?.profileCity && (
            <span className="text-danger">
              {errors?.profileCity?.message || t("cityRequired", { defaultValue: "City is required" })}
            </span>
          )}
        </div>
        <div className="col" id={fieldObj?.fieldCode}>
          <label>
            <Trans i18nKey="state" defaults="State" />
            <span className="text-danger">{"*"}</span>
          </label>
          <Controller
            control={control}
            name="profileState"
            refs={register("profileState", {
              required: true,
              validate:{
                  emptyValue: (v) => v.replace(/\s/g, "") != "",
              }
            })}
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="w-100">
                <NewLocationInput2
                  handlePlaceChange={handleAddressChange}
                  onChange={onChange}
                  value={value}
                  placeholder="Enter Location"
                  size={'sm'}
                  className={'locationInput pt-2'}
                  autoSuggestCssClassName={'w-100'}
                  page={'Search'}
                />
              </div>
            )}
          />
          {errors?.profileState && (
            <span className="text-danger">
              {errors?.profileState?.message || t("stateRequired", { defaultValue: "State is required" })}
            </span>
          )}
        </div>
        <div className="col" id={fieldObj?.fieldCode}>
          <label>
            <Trans i18nKey="country" defaults="Country" />
            <span className="text-danger">{"*"}</span>
          </label>
          <Controller
            control={control}
            name="profileCountry"
            refs={register("profileCountry", {
              required: true,
              validate:{
                  emptyValue: (v) => v.replace(/\s/g, "") != "",
                }
            })}
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="w-100" id={fieldObj?.fieldCode}>
                <NewLocationInput2
                  handlePlaceChange={handleAddressChange}
                  onChange={onChange}
                  value={value}
                  placeholder="Enter Location"
                  size={'sm'}
                  className={'locationInput pt-2'}
                  autoSuggestCssClassName={'w-100'}
                  page={'Search'}
                />
              </div>
            )}
          />
          {errors?.profileCountry && (
            <span className="text-danger">
              {errors?.profileCountry?.message || t("countryRequired", { defaultValue: "Country is required" })}
            </span>
          )}
        </div> 
      </>}
    </>
  );
}
export default ResumeLocationForm;